/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ sold: NonNullable<unknown>, total: NonNullable<unknown> }} Ticketstakenof2Inputs */

const en_ticketstakenof2 = /** @type {(inputs: Ticketstakenof2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.sold} of ${i?.total} taken`)
};

const de_ticketstakenof2 = /** @type {(inputs: Ticketstakenof2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.sold} von ${i?.total} vergeben`)
};

/**
* | output |
* | --- |
* | "{sold} of {total} taken" |
*
* @param {Ticketstakenof2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const ticketstakenof2 = /** @type {((inputs: Ticketstakenof2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticketstakenof2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticketstakenof2(inputs)
	return de_ticketstakenof2(inputs)
});
export { ticketstakenof2 as "ticketsTakenOf" }